<script>
  import { createEventDispatcher } from "svelte";

  import { path, currentStep } from "../store.js";

  export let current;

  let compact;

  $: current, check4compact();

  const check4compact = () => {
    if (current && compact === undefined) {
      const parent = current[current.length - 2];
      const idx = parent.contents.indexOf(current[current.length - 1]);
      compact = !(idx === 0 || parent.contents[idx - 1].type !== 'field');
    }
  }

  const content = elem => {
    switch (elem.type) {
      case 'group':
        return elem.id || elem.tag || elem.class || 'no name';
      case 'value':
        return elem.key;
      case 'clicker':
        return 'Clicker';
      case 'field':
        return elem.id;
      case 'buttons':
        return 'buttons';
      case 'object':
        return elem.title;
    }
  }

  const setPath = child => {
    $path = compact ? current : current.slice(0, current.indexOf(child) + 1);
    dispatch('message', { type: 'pathSelected', path: $path });
  }

  const dispatch = createEventDispatcher();
</script>

{#if compact}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <span class="badge cursor-pointer" class:badge-success={ $path[$path.length - 1] === current[current.length - 1] } on:click={ () => { setPath() } }>
    { content(current[current.length - 1])}
  </span>
{:else}
  <div class="flex flex-wrap">
    {#each current as child}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <span class="badge cursor-pointer" class:badge-primary={ $path.includes(child) && $currentStep !== child } class:badge-success={ $currentStep === child } on:click={ () => { setPath(child) } }>
        { content(child) }
      </span>
    {/each}
  </div>
{/if}